module.exports = __webpack_public_path__ + "static/_ridgetownLogo-a8c6c11299a80e652b175c3b89ebd33f.png";